module.exports = __webpack_public_path__ + "static/media/quiz_male_icon.ceddff8b.svg";